export const ANALYTICS = 'Analytics';
export const CAMPAIGN_BUILDER = 'Campaign builder';
export const MARKETING_SITES = 'Landing pages';
export const COMPANIES = 'Companies';
export const CONTACTS = 'Contacts';
export const DASHBOARD = 'Dashboard';
export const E_COMMERCE = 'E-commerce';
export const EMAIL_ANALYTICS = 'Email Analytics';
export const EMAIL_BROADCASTS = 'Email and broadcasts';
export const INTEGRATIONS = 'Integrations';
export const MY_DAY = 'My day';
export const OPPORTUNITIES = 'Opportunities';
export const REPORTS = 'Reports';
export const OTHER = 'Other';

export const FEATURES = [
    { value: ANALYTICS, label: 'Analytics' },
    { value: CAMPAIGN_BUILDER, label: 'Automations' },
    { value: MARKETING_SITES, label: 'Landing pages' },
    { value: COMPANIES, label: 'Companies' },
    { value: CONTACTS, label: 'Contacts' },
    { value: DASHBOARD, label: 'Dashboard' },
    { value: E_COMMERCE, label: 'E-commerce' },
    { value: EMAIL_ANALYTICS, label: 'Email Analytics' },
    { value: EMAIL_BROADCASTS, label: 'Email and broadcasts' },
    { value: INTEGRATIONS, label: 'Integrations' },
    { value: MY_DAY, label: 'My day' },
    { value: OPPORTUNITIES, label: 'Opportunities' },
    { value: REPORTS, label: 'Reports' },
    { value: OTHER, label: 'Other' },
];
